import Vue from 'vue';
import store from '../../store';
import batchIngredienceTransformer from '../../transformers/batchIngredience';
import batchTransformer from '../../transformers/batch';

const success = (resolve, data) => {
  const batchIngrediences = batchIngredienceTransformer.fetchCollection(data.ingrediences);
  store.dispatch('fetchAllBatchIngrediences', batchIngrediences);
  resolve(batchTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.data.batch) {
    const batchIngrediences = batchIngredienceTransformer.fetchCollection(errors.data.batch.ingrediences);
    store.dispatch('fetchAllBatchIngrediences', batchIngrediences);
  }
  reject(errors);
};

export default (id, data) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/production/batch/${id}/start_batch`, data)
      .then((response) => {
        success(resolve, response.data);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batch/startBatch.js